class VicVintageSlider extends HTMLElement {
    constructor() {
        super();
        this.track = this.querySelector('.vic-slider__track');
        this.slides = this.querySelectorAll('.vic-slider__slide');
        this.prevBtn = this.querySelector('.vic-slider__nav--prev');
        this.nextBtn = this.querySelector('.vic-slider__nav--next');
        this.dots = this.querySelectorAll('.vic-slider__dot');

        if (!this.track || this.slides.length <= 1) return;

        this.currentIndex = 0;
        this.autoPlaySpeed = parseInt(this.dataset.autoplay) || 0;
        this.autoPlayInterval = null;

        this.bindEvents();
        this.startAutoPlay();

        // Shopify Theme Editor Support
        if (window.Shopify && Shopify.DesignMode) {
            this.addEventListener('shopify:block:select', this.onBlockSelect.bind(this));
            this.addEventListener('shopify:block:deselect', this.startAutoPlay.bind(this));
        }
    }

    bindEvents() {
        if (this.prevBtn) {
            this.prevBtn.addEventListener('click', () => {
                this.prevSlide();
                this.resetAutoPlay();
            });
        }
        if (this.nextBtn) {
            this.nextBtn.addEventListener('click', () => {
                this.nextSlide();
                this.resetAutoPlay();
            });
        }

        this.dots.forEach((dot, index) => {
            dot.addEventListener('click', () => {
                this.goToSlide(index);
                this.resetAutoPlay();
            });
        });
    }

    goToSlide(index) {
        this.currentIndex = index;
        if (this.currentIndex < 0) this.currentIndex = this.slides.length - 1;
        if (this.currentIndex >= this.slides.length) this.currentIndex = 0;

        this.track.style.transform = `translateX(-${this.currentIndex * 100}%)`;

        this.dots.forEach((dot, i) => {
            dot.classList.toggle('vic-slider__dot--active', i === this.currentIndex);
        });
    }

    nextSlide() {
        this.goToSlide(this.currentIndex + 1);
    }

    prevSlide() {
        this.goToSlide(this.currentIndex - 1);
    }

    startAutoPlay() {
        if (this.autoPlaySpeed > 0) {
            this.autoPlayInterval = setInterval(() => {
                this.nextSlide();
            }, this.autoPlaySpeed * 1000);
        }
    }

    resetAutoPlay() {
        clearInterval(this.autoPlayInterval);
        this.startAutoPlay();
    }

    onBlockSelect(e) {
        const slideIndex = Array.from(this.slides).findIndex(s => s.dataset.blockId === e.detail.blockId);
        if (slideIndex !== -1) {
            this.goToSlide(slideIndex);
            clearInterval(this.autoPlayInterval);
        }
    }
}

if (!customElements.get('vic-vintage-slider')) {
    customElements.define('vic-vintage-slider', VicVintageSlider);
}
